import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=72a0f4f6&scoped=true"
import script from "./FormList.vue?vue&type=script&lang=js"
export * from "./FormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0f4f6",
  null
  
)

export default component.exports